<app-wrapper>

  <div class="mb-9">
    <div class="row g-3 mb-4">
      <div class="col-auto">
        <h2 class="mb-0">Продукты</h2>
      </div>
    </div>

    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <div class="search-box">
            <div class="position-relative">
              <input type="text" class="form-control search-input search" [(ngModel)]="search"
                name="search" placeholder="Поиск" (keyup.enter)="searchItems()" />
                <i class="fa-solid fa-search search-box-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-auto flex-grow-1">

          </div>
        </div>
      </div>
      <div class="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-200 position-relative top-1">
        <div class="table-responsive mx-n1 px-1">
          <table class="table fs--1 mb-0">
            <thead>
              <tr>
                <th style="width: 15%;" class="text-center">Картинка</th>
                <th style="width: 60%;">Название</th>
                <th style="width: 15%;"></th>
              </tr>
            </thead>
            <tbody class="list">
              @for (item of items; track item) {
                <tr>
                  <td class="text-center">
                    <img class="image" [src]="item.image" />
                  </td>
                  <td>
                    {{ item.name }}
                  </td>
                  <td class="text-center">
                    <button class="btn btn-primary" data-bs-toggle="modal" (click)="setLinks(item)"
                      data-bs-target="#list-of-links-modal">
                      <i class="fa-solid fa-eye"></i>
                    </button>
                  </td>
                </tr>
              }
              @if (!isBusy && items.length == 0) {
                <tr>
                  <td colspan="10" class="text-center">
                    Список пуст
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end py-2 pe-0 fs--1">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [ngClass]="{'disabled': page === 1}" (click)="getData(page - 1)">
              <a onclick="return false;" class="page-link" href="#" tabindex="-1">
                <span aria-hidden="true"><i class="fa-solid fa-chevron-left"></i></span>
              </a>
            </li>
            @for (item of getPages(); track item) {
              <li class="page-item"
                [ngClass]="{'active': page === item.page, 'disabled': item.isDisabled}"
                (click)="getData(item.page)">
                <a class="page-link" onclick="return false;" href="#">{{ item.label }}</a>
              </li>
            }
            <li class="page-item" [ngClass]="{ 'disabled': !pages || page === pages }"
              (click)="getData(page + 1)">
              <a onclick="return false;" class="page-link" href="#">
                <span aria-hidden="true"><i class="fa-solid fa-chevron-right"></i></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      @if (isBusy) {
        <div class="overlay">
          <i class="fa-solid fa-spinner fa-spin"></i>
        </div>
      }
    </div>

  </app-wrapper>

  <div class="modal fade" id="list-of-links-modal" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h5 class="modal-title text-white">Ссылки</h5>
          <button class="btn p-1" type="button" data-bs-dismiss="modal" aria-label="Close">
            <span class="fas fa-times fs--1 text-white"></span>
          </button>
        </div>
        <div class="modal-body">

          <form #form="ngForm" class="add-link w-100">
            <div class="row">
              <div class="col-md-3 col-6">
                <div class="dropdown">
                  <input type="text" class="form-control" placeholder="Продукт" data-bs-toggle="dropdown"
                    data-bs-config='{"popperConfig":{"strategy":"fixed"}}' data-bs-display="static"
                    [(ngModel)]="searchLink" name="newLink" required (keydown)="onSearch()" />
                    <ul class="dropdown-menu">
                      @for (item of searchedLinks; track item) {
                        <li (click)="onSelect(item)">
                          @if (item.image) {
                            <img [src]="item.image" width="25" />
                          }
                          &nbsp;{{item.name}}
                        </li>
                      }
                    </ul>
                  </div>

                </div>
                <div class="col-md-3 col-6">
                  <button class="btn btn-outline-primary" (click)="onAdd()" type="button"
                  [disabled]="!newLink">Добавить</button>
                </div>
              </div>
            </form>

            <h3 class="mt-2">Добавленные ссылки</h3>
            <div
              class="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-200 position-relative top-1">
              <div class="table-responsive mx-n1 px-1">
                <table class="table fs--1 mb-0">
                  <thead>
                    <tr>
                      <th style="width: 15%;" class="text-center">Картинка</th>
                      <th style="width: 60%;">Название</th>
                      <th style="width: 15%;"></th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    @for (item of selected?.links; track item) {
                      <tr>
                        <td class="text-center">
                          <img class="image" [src]="item.image" />
                        </td>
                        <td>
                          {{ item.name }}
                        </td>
                        <td class="text-center">
                          <button class="btn btn-danger" (click)="deleteLink(item)">
                            <i class="fa-solid fa-times"></i>
                          </button>
                        </td>
                      </tr>
                    }
                    @if (selected?.links?.length == 0) {
                      <tr>
                        <td colspan="10" class="text-center">
                          Список пуст
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button class="btn btn-outline-success" type="button" (click)="saveLinks()" [disabled]="isSave">
              @if (!isSave) {
                <i class="fa-solid fa-save"></i>
              }
              @if (isSave) {
                <i class="fa-solid fa-spinner fa-spin"></i>
              }
              Сохранить
            </button>
            <button class="btn btn-outline-primary" type="button" data-bs-dismiss="modal">Закрыть</button>
          </div>
        </div>
      </div>
    </div>